import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getInsightsRecentSold } from 'Services/api/insights/recentSold';
import { logger } from 'Services/logger/logger';
import type {
	InsightsRecentSoldData,
	InsightsRecentSoldParams,
} from 'Services/motorway/services/insights/insights.types';
import { isE2ETestEnv, isTestEnv } from 'Utilities/helpers';
import isClientSideAuth from 'Utilities/helpers/isClientSideAuth';

export type UseInsightsRecentSoldParams = InsightsRecentSoldParams;
export type UseInsightsRecentSoldResult = UseQueryResult<InsightsRecentSoldData>;

export const useInsightsRecentSold = ({ makeId, modelId }: UseInsightsRecentSoldParams): UseInsightsRecentSoldResult =>
	useQuery({
		onError: (e) => {
			const message = 'There was an issue with fetching recent sold insights';
			const error = e instanceof Error ? e : new Error(message);
			logger.error({ context: { extra: { info: message } }, error, message, scope: 'useInsightsRecentSold' });
		},
		queryFn: () => getInsightsRecentSold({ params: { makeId, modelId } }),
		queryKey: ['insightsRecentSold', { makeId, modelId }],
		refetchOnWindowFocus: () => isClientSideAuth(),
		retry: isTestEnv || isE2ETestEnv() ? 0 : undefined,
	});
